import type { Supplier } from '../../shared/api/suppliers.api'

// Полнота карточки поставщика (этап 3, кусок C3): «заполнено 3 из 7» —
// чтобы РОЗ видела, где пусто. Ничего не блокирует: пустое поле — не ошибка,
// справочник дозаполняется по ходу работы.

interface CompletenessField {
  /** Как поле называется в строке «Не заполнено: …». */
  label: string
  filled: (s: Supplier) => boolean
  /** Поле нужно не при любых условиях оплаты. Не задано — нужно всегда. */
  applies?: (s: Supplier) => boolean
}

// При 100% предоплате кредитного лимита и отсрочки после отгрузки не бывает —
// требовать их значит навсегда оставить карточку «недозаполненной».
const hasCreditTerms = (s: Supplier) => s.paymentType !== 'PREPAY_100'

export const COMPLETENESS_FIELDS: CompletenessField[] = [
  { label: 'тип', filled: (s) => s.type != null },
  { label: 'ответственный закупщик', filled: (s) => s.responsibleBuyerId != null },
  { label: 'условия оплаты', filled: (s) => s.paymentType != null },
  {
    label: 'кредитный лимит',
    filled: (s) => s.creditLimitAmount != null && s.creditLimitAmount !== '',
    applies: hasCreditTerms,
  },
  {
    label: 'отсрочка после отгрузки',
    filled: (s) => s.postShipmentDays != null,
    applies: hasCreditTerms,
  },
  { label: 'гарантия', filled: (s) => s.warrantyDays != null },
  { label: 'рейтинг', filled: (s) => s.rating != null },
]

export interface SupplierCompleteness {
  filled: number
  total: number
  /** Незаполненные поля — в порядке карточки. */
  missing: string[]
}

export function supplierCompleteness(s: Supplier): SupplierCompleteness {
  const fields = COMPLETENESS_FIELDS.filter((f) => !f.applies || f.applies(s))
  const missing = fields.filter((f) => !f.filled(s)).map((f) => f.label)
  return { filled: fields.length - missing.length, total: fields.length, missing }
}
